import './style.css'
import { GameController, type MetaphorgeDebugApi } from './app/GameController'

declare global {
  interface Window {
    __METAPHORGE__?: MetaphorgeDebugApi
  }
}

const root = document.querySelector<HTMLDivElement>('#app')
if (root === null) throw new Error('App root was not found')

const controller = new GameController(root)
controller.start()
window.__METAPHORGE__ = controller.getDebugApi()
